import { Injectable } from '@angular/core';
import { pyramidBarData } from './pyramid-bar-interface';
import * as _ from 'lodash';
import * as legend from '../../config/legend'
import * as series from '../../config/series'
import * as toolbox from '../../config/toolbox'
import * as tooltip from '../../config/tootip'
import * as xAxis from '../../config/xAxis'
import * as yAxis from '../../config/yAxis'
import * as datazoom from '../../config/datazoom';
import * as backgroundColor from '../../config/backgroundColor';
import * as colors from '../../config/colors';
import * as textStyle from '../../config/textStyle';
import { CommonService } from '../../service/common.service';
import { ChartDarkModeService } from '../../service/chart-dark-mode.service';
import { axisLabelRotate } from './pyramid-bar.component';


@Injectable({
  providedIn: 'root'
})
export class PyramidBarService {

  constructor(
    private commonService: CommonService,
  ) { }

  getPyramidBarChartDefaultOption() {
    let style = this.commonService.changeFontSize();
    const options = {
      color: colors.defaultColors,
      backgroundColor: backgroundColor.backgroundColor,
      grid: style.pyramidGrid,
      legend: legend.getLegendBottomScroll(style),
      // toolbox: toolbox.getToolboxBasicMenu(),
      tooltip: tooltip.getPyramidChartTooltip(),
      xAxis: xAxis.getPyramidValueAxis(style),
      yAxis: yAxis.getDoubleCategoryYAxis(style),
      series: series.getPyramidBarChartSeries(),
      textStyle: textStyle.getTextStyle()
    }
    return options;
  }
  // changeToolboxShow(options, show: boolean) {
  //    options.toolbox.show = show;
  // }

  changeLegendShow(options, show: boolean) {
    options.legend.show = show;
  }

  changeChartData(options, data: pyramidBarData) {

    data = _.cloneDeep(data)  //克隆当前数据

    if (data && data.hasOwnProperty('xData') && data.xData && Array.isArray(data.xData[0])) {
      for (let i = 0; i < data.xData[0].length; i++) {
        data.xData[0][i] = _.subtract(0, +data.xData[0][i]).toFixed(1);  //取相反数
      }
    }

    if (data && data.hasOwnProperty('yData')) {
      options.yAxis[0].data = data.yData[0];
      options.yAxis[1].data = data.yData[1];
    }

    if(data && data.hasOwnProperty('xData')) {
      options.series = series.getPyramidBarChartSeries(data);
    }
  }
  // 更改tooltip
  changeTooltip(chartOpt, tooltipUnit: string) {
    chartOpt.tooltip = tooltip.getPyramidChartTooltip(tooltipUnit)
  }
  // 更改XAxisName
  changeXAxisName(chartOpt, xAxisName: string) {
    chartOpt.xAxis[0].name = xAxisName;
  }
  // 更改yAxisName
  changeYAxisName(chartOpt, yAxisName: string) {
    chartOpt.yAxis[0].name = yAxisName;
    chartOpt.yAxis[1].name = yAxisName;
  }
  // 更改yAxisNameGap
  changeYAxisNameGap(chartOpt, yAxisNameGap: number[]) {
    // chartOpt.yAxis[0].nameGap = yAxisNameGap;
    // chartOpt.yAxis[1].nameGap = yAxisNameGap;
    chartOpt.yAxis.forEach((e, i) => {
      e.nameGap = yAxisNameGap[i];
    });
  }
  // x轴label的旋转
  changeXAxisLabelRotate(chartOpt, xAxisLabelRotate: axisLabelRotate) {
    let rotate = 0;
    switch (xAxisLabelRotate) {
      case 'leftSmallAngle':
        rotate = 30
        break;
      case 'leftBigAngle':
        rotate = 60
        break;
      case 'rightSmallAngle':
        rotate = -30
        break;
      case 'rightBigAngle':
        rotate = -60
        break
    }
    chartOpt.xAxis[0].axisLabel.rotate = rotate;
  }
  // y轴label的选装
  changeYAxisLabelRotate(chartOpt, yAxisLabelRotate: axisLabelRotate) {
    let rotate = 0;
    switch (yAxisLabelRotate) {
      case 'leftSmallAngle':
        rotate = 30
        break;
      case 'leftBigAngle':
        rotate = 60
        break;
      case 'rightSmallAngle':
        rotate = -30
        break;
      case 'rightBigAngle':
        rotate = -60
        break
    }
    chartOpt.yAxis[0].axisLabel.rotate = rotate;
    chartOpt.yAxis[0].axisLabel.formatter = (value: string): string => {
      let valueText = '';
      if (value.length > 5) {
        valueText = value.substring(0, 5) + '...'
      } else {
        valueText = value
      }
      return valueText;
    }
    chartOpt.yAxis[1].axisLabel.rotate = rotate;
    chartOpt.yAxis[1].axisLabel.formatter = (value: string): string => {
      let valueText = '';
      if (value.length > 5) {
        valueText = value.substring(0, 5) + '...'
      } else {
        valueText = value
      }
      return valueText;
    }
  }

  setInterval(chartOpt, interval: number | string) {
    // chartOpt.yAxis[0].axisLabel.interval = interval;
    // chartOpt.yAxis[1].axisLabel.interval = interval;
    chartOpt.yAxis.forEach(e => {
      e.axisLabel.interval = interval
    })
  }

  changeXAxisMax(chartOpt, xAxisMax: number[]) {
    if (Array.isArray(xAxisMax)) {
      if (_.isNumber(xAxisMax[0])) {
        chartOpt.xAxis[0].min = (-xAxisMax[0])
      }
      if (_.isNumber(xAxisMax[1])) {
        chartOpt.xAxis[0].max = xAxisMax[1]
      }
    }
  }

  changeXAxisInterval(chartOpt, xAxisInterval: number) {
    chartOpt.xAxis.forEach(e => {
      e.interval = xAxisInterval;
    })
  }
}
